import { render, staticRenderFns } from "./IssuesInsights.vue?vue&type=template&id=6b66cc7d&"
import script from "./IssuesInsights.vue?vue&type=script&lang=js&"
export * from "./IssuesInsights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b66cc7d')) {
      api.createRecord('6b66cc7d', component.options)
    } else {
      api.reload('6b66cc7d', component.options)
    }
    module.hot.accept("./IssuesInsights.vue?vue&type=template&id=6b66cc7d&", function () {
      api.rerender('6b66cc7d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/Reports/IssuesInsights.vue"
export default component.exports